var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","id":"FprmFillUpDetails"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[(_vm.getStudentConfirmedData.hasOwnProperty('papers'))?_c('studentConfirmedPaper',{attrs:{"formFillUpData":_vm.getStudentConfirmedData}}):_vm._e(),(
              _vm.getStudentFormFillUpFeeHistory.hasOwnProperty(
                'form_fill_up_fee'
              )
            )?_c('StudentFormFillUpFeeHistory',{attrs:{"StudentFormFillUpFeeHistoryData":_vm.getStudentFormFillUpFeeHistory}}):_vm._e()],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }